<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Shipping Information</legend>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <labeled-input autocomplete="name" label="Practice Name *" name="Company Name" v-model='sampleobject.name'></labeled-input>
                </div>
            </div>
            <div class="row">
                <labeled-input label="Address Line 1 (no P.O. boxes please) *" name="Address line 1" v-model='sampleobject.addressLine1'></labeled-input>
            </div>
            <div class="row">
                <labeled-input validation="" label="Address Line 2" name="Address line 2" v-model='sampleobject.addressLine2'></labeled-input>
            </div>
            <div class="row">
                <div class="medium-7 columns lp">
                    <labeled-input label="City *" name="City" v-model='sampleobject.city'></labeled-input>
                </div>
                <div class="medium-2 columns lp">
                    <div :class="{'error': errors.has('State / Region') }">
                        <label for="region">State / Region *</label>
                        <input id="region" type="text" v-validate="'required|min:2'" name="State / Region" class="full-txt" maxlength="2" placeholder="" v-model='sampleobject.region'>
                        <p class="error" v-if="errors.has('State / Region')">{{ errors.first('State / Region') }}</p>
                    </div>
                </div>
                <div class="medium-3 columns lp end">
                    <labeled-input label="Postal Code *" name="Postal Code" v-model='sampleobject.postalCode'></labeled-input>
                </div>
            </div>
            <div class="row">
              <small class="error">{{ errorResponseData }}</small>
            </div>
            <div class="row">
              <div class="medium-6 columns lp">
                  <div :class="{'error': errors.has('Telephone') }">
                      <label for="telephone">Office Phone Number *</label>
                      <input id="telephone" @blur="formatShippingPhoneNumber()" type="text" v-validate="'required'" name="Telephone" class="full-txt" placeholder="" v-model='sampleobject.phone'>
                      <p class="error" v-if="errors.has('Telephone')">{{ errors.first('Telephone') }}</p>
                  </div>
              </div>
              <div class="medium-6 columns lp">
                  <div :class="{'error': errors.has('Mobile Phone') || errorMessage }">
                      <label for="mobilephone">
                          Personal Cell Number
                          *
                      </label>
                      <div class="input-container">
                          <input id="mobilephone" @blur="formatShippingMobilePhoneNumber()" type="text" v-validate="'required'" name="Mobile Phone" class="full-txt number" placeholder="" v-model='sampleobject.mobilePhone'>
                      </div>
                      <small class="small-text text-blue">Please ensure that the cell information provided is your personal number and not your office contact information.</small>
                      <p class="error" v-if="errors.has('Mobile Phone') || errorMessage">{{ errors.first('Mobile Phone') || errorMessage }}</p>
                  </div>
              </div>
            </div>
            <div class="row">
                <div class="medium-8 columns lp">
                    <labeled-input validation="required|email" label="Email *" name="Email" autocomplete="on" v-model='sampleobject.email' @change="validateEmail"></labeled-input>
                    <small class="duplicate-error" v-if="hasNoSupplier" v-html="supplierNotFoundMessage"></small>
                    <small class="duplicate-error" v-if="hasInvalidGeoInfo" v-html="invalidGeoInfo"></small>
                    <small class="duplicate-error" v-if="hasInvalidEmail" v-html="invalidEmail"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder1" v-html="duplicateOrderMessage1"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder2" v-html="duplicateOrderMessage2"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder3" v-html="duplicateOrderMessage3"></small>
                </div>
            </div>
        </fieldset>
        <!-- Address Override Modal -->
        <div v-if="showOverrideModal" class="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="override-title">
          <div class="modal-container">
            <h3>Address Validation Warning</h3>

            <div class="modal-body">
              <!-- dynamic address error message -->
              <p class="error-text" v-if="addressErrorMessage">{{ addressErrorMessage }}</p>

               <p> 
                 Our system was unable to fully validate the entered address.
                 Please review the details carefully and ensure that your address
                 is complete and accurate.
               </p>

               <p>
                 Incorrect addresses may result in delivery delays or failed
                 shipments. By proceeding, you acknowledge that you are confirming
                 the accuracy of the provided address.
               </p>
             </div>

             <div class="modal-actions">
              
               <button
                 type="button"
                 class="button secondary"
                 @click="proceedAnyway"
               >
                 Proceed Anyway
               </button>
               <button
                 type="button"
                 class="button primary"
                 @click="editAddress"
               >
                 Edit Address
               </button>
             </div>
           </div>
         </div>
         <!-- Suggested Address Modal -->
        <div
          v-if="showSuggestionModal && suggestedAddress"
          class="modal-overlay"
          role="dialog"
          aria-modal="true"
        >
          <div class="modal-container">
            <h3>Verify your address</h3>

            <div class="modal-body">
              <p>
                Please review the options below and select the address you would like to use.
                To avoid delays, please use the recommended address.
              </p>

              <div class="address-compare">

                <div>
                  <strong>Original address:</strong>
                    <p>{{ formattedOriginalAddress }}</p>
                </div>
                <div>
                  <strong>Recommended address:</strong>
                  <p>{{ suggestedAddress.formatted }}</p>
                </div>
              </div>
            </div>

            <div class="modal-actions">
              <button
                type="button"
                class="button secondary"
                @click="dismissSuggestedAddress"
              >
                Use Original Address
              </button>

              <button
                type="button"
                class="button primary"
                @click="applySuggestedAddress"
              >
                Use Recommended Address
              </button>
            </div>
          </div>
        </div>

    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["sampleobject", "choices"],
  inject: ["$validator"],
  components: { LabeledInput },
  data() {
    return {
      timeOutTimer: null,
      hasDuplicateOrder1: false,
      hasDuplicateOrder2: false,
      hasDuplicateOrder3: false,
      hasInvalidGeoInfo: false,
      hasInvalidEmail: false,
      duplicateOrderMessageCNL: `Our records indicate that you have already ordered a Crizal Natural Look Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Crizal Natural Look</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessageMid: `Our records indicate that you have already ordered a Varilux Immersia Mid Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Immersia Mid</strong> more details, please contact your sales representative.`,
      duplicateOrderMessageRoom: `Our records indicate that you have already ordered a Varilux Immersia Room Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Immersia Room</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessageExtensee: `Our records indicate that you have already ordered a Varilux Physio Extensee Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Physio Extensee</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessageClassic: `Our records indicate that you have already ordered a Varilux Physio Extensee Classic Edition Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Physio Extensee Classic Edition</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessageTrack: `Our records indicate that you have already ordered a Varilux Physio Extensee Track. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Physio Extensee Track</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessage1: `Our records indicate that you have already ordered a Varilux I design Evaluation Product. Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of <strong>Varilux Shift</strong>. For more details, please contact your sales representative.`,
      duplicateOrderMessage2: `Essilor has determined that it is reasonable to offer all eligible employees professional eyecare practices with only limited evaluation products. For more details, please contact your sales representative.`,
      duplicateOrderMessage3: `Our records indicate that you have already ordered this particular combination of Essilor products. 
	Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of lenses with these specific attributes. 
	For more details, please contact your sales representative.`,
      invalidGeoInfo: ` Invalid Geo information. `,
      invalidEmail: `This portal is strictly for employees of professional eyecare practices in a customer-facing role like opticians, optometrists, ophthalmologists, technicians, and eyewear consultants. `,
      errorMessage: '',
      showInfo: false,
      supplierNotFoundMessage: 'Missing lab to process',
      hasNoSupplier: false,
      errorResponseData: "",
      suggestedAddress: null,
      showSuggestionModal: false,
      showOverrideModal: false,
      addressErrorMessage: "",
      addressOverrideSelected: false,
    };
  },
  computed: {
    duplicateOrderHasUpdate() {
      const { firstName, lastName, email, couponCode, mobilePhone, treatment, design, photochromic, material } = this.sampleobject;
      return {
        firstName,
        lastName,
        email,
        couponCode,
        mobilePhone,
        design,
        material,
        photochromic,
        treatment,
      };
    },
    isPhotochromicVisible() {
      return (
        this.choices &&
        this.choices.photochromic &&
        this.choices.photochromic.length > 1
      );
    },
    isTreatmentVisible() {
      return (
        this.choices &&
        this.choices.treatment &&
        this.choices.treatment.length > 1
      );
    },
    formattedOriginalAddress() {
        const {
          addressLine1,
          addressLine2,
          city,
          region,
          postalCode
        } = this.sampleobject;
        console.log('Formatting original address with: ', {
          addressLine1,
          addressLine2,
          city,
          region,
          postalCode
        });
        return `${addressLine1}${
          addressLine2 ? "\n" + addressLine2.trim() : ""
        }\n${city}, ${region} ${postalCode}`;
      }
  },
  methods: {
    validate() {
      this.$validator.validateAll();
    },
    formatShippingPhoneNumber() {
      this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
    },
    formatShippingMobilePhoneNumber() {
      this.sampleobject.mobilePhone = this.formatPhoneNumber(this.sampleobject.mobilePhone, 'mobilePhone');
    },
    formatPhoneNumber(args, type = 'telephone') {
      var s2 = ("" + args).replace(/\D/g, "");
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (type === 'mobilePhone' && !m) {
        this.errorMessage = "The Mobile Phone field must be 10 digits.";
        return args;
      }
      else this.errorMessage = ""
      return !m ? null : m[1] + "-" + m[2] + "-" + m[3];
    },
    checkDuplicateOrder() {
      const {
        firstName,
        lastName,
        email,
        couponCode,
        mobilePhone,
        design,
        material,
        photochromic,
        treatment
      } = this.sampleobject;

      if (
        !firstName ||
        !lastName ||
        !email ||
        !mobilePhone ||
        !material ||
        !design ||
        !photochromic
      ) {
        return;
      }

      if (treatment === null && this.choices.treatment.length > 0) {
        return
      }

      axios
        .get(`/order?firstname=${firstName}&lastname=${lastName}&email=${email}&coupon=${couponCode}&mobilephone=${mobilePhone}&treatment=${treatment}&design=${design}&material=${material}&photochromic=${photochromic}`)
        .then((response) => {
          const responseList = response.data.split('|');
          const duplicateOrderResponse = responseList[0];
          if (duplicateOrderResponse.toLowerCase() === "ok") {
            this.hasDuplicateOrder1 = false;
            this.hasDuplicateOrder2 = false;
            this.hasDuplicateOrder3 = false;
            this.$emit('hasDuplicateOrder1', false);
            this.$emit('hasDuplicateOrder2', false);
            this.$emit('hasDuplicateOrder3', false);
          }
        })
        .catch((error) => {
          const errorList = error.response.data.split('|');
          const duplicateOrderResponse = errorList[0];
          const legacyOrderResponse = errorList[1];
          if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "false") {
            this.hasDuplicateOrder1 = true;
            this.$emit('hasDuplicateOrder1', true);
          }
          if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "true") {
            this.hasDuplicateOrder1 = false;
            this.hasDuplicateOrder2 = true;
            this.hasDuplicateOrder3 = false;
            this.$emit('hasDuplicateOrder1', false);
            this.$emit('hasDuplicateOrder2', true);
            this.$emit('hasDuplicateOrder3', false);
          }
          if (duplicateOrderResponse.toLowerCase() === "already ordered" && (legacyOrderResponse.toLowerCase() === "true" || legacyOrderResponse.toLowerCase() === "false")) {
            this.hasDuplicateOrder3 = true;
            this.hasDuplicateOrder2 = false;
            this.hasDuplicateOrder1 = false;
            this.$emit('hasDuplicateOrder1', false);
            this.$emit('hasDuplicateOrder3', true);
            this.$emit('hasDuplicateOrder2', false);
          }
          if (duplicateOrderResponse.toLowerCase() === "geo tag id not found") {
            this.hasInvalidGeoInfo = true;
            this.$emit('hasInvalidGeoInfo', true);
          }
          if (duplicateOrderResponse.toLowerCase() === "supplier not found") {
            this.hasNoSupplier = true;
            this.$emit('hasNoSupplier', true);
          }
          this.setDuplicateOrderMessageByCoupon();
        });
        
    },
    validateEmail(email) {
      const emailFiltered = email;
      // Check if email is undefined or null
      if (emailFiltered == null) {
        return;
      }

      if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com")) {
      if (this.sampleobject.programType == 'Employee' || this.sampleobject.programType == 'SalesRep') {
          this.hasInvalidEmail = false;
        } else {
          this.hasInvalidEmail = true;
        }
      } else {
        this.hasInvalidEmail = false;
      }
      this.$emit('hasInvalidEmail', this.hasInvalidEmail);
    },
    setDuplicateOrderMessageByCoupon() {
      var code = (this.sampleobject.couponCode ? this.sampleobject.couponCode.toUpperCase() : '');
      console.log('Coupon Code: ' + code);
      if (code.includes('VPT')) {
        this.hasDuplicateOrder1 = true;
        this.$emit('hasDuplicateOrder1', true);
        this.duplicateOrderMessage1 = this.duplicateOrderMessageTrack;
      } else if (code.includes('VPC')) {
        this.hasDuplicateOrder1 = true;
        this.$emit('hasDuplicateOrder1', true);
        this.duplicateOrderMessage1 = this.duplicateOrderMessageClassic;
      } else if (code.includes('VPE')) {
        this.$emit('hasDuplicateOrder1', true);
        this.hasDuplicateOrder1 = true;
        this.duplicateOrderMessage1 = this.duplicateOrderMessageExtensee;
      } else if (code.includes('VIR')) {
        this.hasDuplicateOrder1 = true;
        this.$emit('hasDuplicateOrder1', true);
        this.duplicateOrderMessage1 = this.duplicateOrderMessageRoom;
      } else if (code.includes('VIM')) {
        this.hasDuplicateOrder1 = true;
        this.$emit('hasDuplicateOrder1', true);
        this.duplicateOrderMessage1 = this.duplicateOrderMessageMid;
      } else if (code.includes('CNL')) {
        this.hasDuplicateOrder1 = true;
        this.$emit('hasDuplicateOrder1', true);
        this.duplicateOrderMessage1 = this.duplicateOrderMessageCNL;
      }
    },
    checkAddress() {
      const { addressLine1, addressLine2, city, region, postalCode, couponCode } =
        this.sampleobject;

      if (!addressLine1 || !city || !region || !postalCode || !couponCode) {
        return;
      }

      const payload = {
        address1: addressLine1,
        address2: addressLine2 || "",
        city: city,
        state: region,
        postalCode: postalCode
      };

      axios
        .post(`/order/ValidateAddress?couponCode=${couponCode}`, payload)
        .then((response) => {
          const { AddressLine1, AddressLine2, City, State, PostalCode } =
            response.data;

          const formatted = `${AddressLine1}${
            AddressLine2 ? "" + AddressLine2.trim() : ""
          }\n${City}, ${State} ${PostalCode}`;

          const different =
            AddressLine1 !== addressLine1 ||
            (AddressLine2 || "").trim() !== (addressLine2 || "").trim() ||
            City !== city ||
            State !== region ||
            PostalCode !== postalCode;

          if (different) {
            this.suggestedAddress = {
              AddressLine1,
              AddressLine2,
              City,
              State,
              PostalCode,
              formatted
            };
            // show suggestion modal so user can choose to apply or dismiss
            this.showSuggestionModal = true;
          }

          this.$emit("addressValidationError", false);
        })
        .catch((error) => {
          const message =
            (error && error.response && error.response.data) ||
            "Address validation failed.";

          this.addressErrorMessage = message;

          // Instead of only emitting error — show modal
          this.showOverrideModal = true;

          this.$emit("addressValidationError", true);
        });

    },

    // Apply the currently suggested address into the form and clear the suggestion
    applySuggestedAddress() {
      if (!this.suggestedAddress) return;
      this.sampleobject.addressLine1 = this.suggestedAddress.AddressLine1;
      this.sampleobject.addressLine2 = (this.suggestedAddress.AddressLine2 || "").trim() || null;
      this.sampleobject.city = this.suggestedAddress.City;
      this.sampleobject.region = this.suggestedAddress.State;
      this.sampleobject.postalCode = this.suggestedAddress.PostalCode;
      this.showSuggestionModal = false;
      this.suggestedAddress = null;
      this.$emit("addressSuggestionApplied", true);
    },

    dismissSuggestedAddress() {
      this.suggestedAddress = null;
      this.showSuggestionModal = false;

      if (this.sampleobject) {
        this.sampleobject.UseManualAddress = false;
      }

      this.$emit("addressSuggestionApplied", false);
    },

    clearAddressErrors() {
      if (this.errorResponseData) {
        this.errorResponseData = "";
      }
      this.$emit("addressValidationError", false);
    },

    checkAddressFields() {
      const { addressLine1, city, region, postalCode, couponCode } = this.sampleobject;
      if (
        !!addressLine1 &&
        !!city &&
        !!region &&
        !!postalCode &&
        !!couponCode
      ) {
        clearTimeout(this.timeOutTimer);
        this.timeOutTimer = setTimeout(() => {
          this.checkAddress();
        }, 1000);
      }
    },
    editAddress() {
      this.showOverrideModal = false;

      if (this.sampleobject) {
        this.sampleobject.UseManualAddress = false;
      }

      this.$emit("addressValidationError", false);
    },
    proceedAnyway() {
      this.addressOverrideSelected = true;

      if (this.sampleobject) {
        this.sampleobject.addressOverride = true;
        this.sampleobject.UseManualAddress = true;
      }

      this.showOverrideModal = false;
      this.$emit("addressOverrideSelected", true);
      this.$emit("addressValidationError", false);
    }
  },
  created() {
    this.formatShippingPhoneNumber();
    if (this.sampleobject.mobilePhone)
      this.formatShippingMobilePhoneNumber();
  },
  watch: {
    duplicateOrderHasUpdate: {
      handler: function(data) {
        const {
          firstName,
          lastName,
          email,
          mobilePhone,
          design,
          material,
          photochromic,
          treatment
        } = data;

        if (
          !!firstName &&
          !!lastName &&
          !!email &&
          !!mobilePhone &&
          !!material &&
          !!design &&
          !!photochromic
        ) {
          clearTimeout(this.timeOutTimer);
          this.timeOutTimer = setTimeout(() => {
            this.checkDuplicateOrder();
          }, 1000);
        }
      },
      deep: true
    },
    'sampleobject.email': {
      handler: function(email) {
        this.validateEmail(email);
      },
      immediate: true
    },
    'sampleobject.addressLine1': {
      handler: function() {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
    'sampleobject.city': {
      handler: function() {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
    'sampleobject.region': {
      handler: function() {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
    'sampleobject.postalCode': {
      handler: function() {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
    'sampleobject.addressLine2': {
      handler: function() {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
    'sampleobject.couponCode': {
      handler: function(couponCode) {
        this.clearAddressErrors();
        this.checkAddressFields();
      }
    },
  }
};
</script>
<style>
.address-suggestion-box {
  display: inline-block;
  width: 50%;
  box-sizing: border-box;
  vertical-align: top;

  background-color: #f5f9ff;
  padding: 5px;
  margin-bottom: 5px;
  border-radius: 4px;
}

.suggested-address-text {
  background: #ffffff;
  border: 1px solid #ddd;
  padding: 10px;
  margin: 10px 0;
  white-space: pre-wrap;
  box-sizing: border-box;
}

@media (max-width: 640px) {
  .address-suggestion-box {
    width: 100%;
    display: block;
  }
}
.suggestion-actions {
  display: flex;
  gap: 10px;
}

.button.primary {
  background-color: #00f;
  color: white;
  border: none;
  padding: 8px 14px;
  cursor: pointer;
}

.button.secondary {
  background-color: #ccc;
  border: none;
  padding: 8px 14px;
  cursor: pointer;
}
.duplicate-error {
    color: red;
}
.note {
  color: red;
  font-weight: bold;
  font-size: 11px;
}
.error {
  color: red;
}

/* Basic modal styles for override dialog */
.modal-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-container {
  background: white;
  padding: 20px;
  width: 560px;
  max-width: calc(100% - 40px);
  border-radius: 4px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
}
.modal-body { margin: 12px 0; }
.modal-actions { 
  display:flex; gap:10px; 
  justify-content:flex-end; 
  margin-top:10px; 
}
.modal-actions .button {
  font-size: 1.26rem;
  padding: 0.85em 1.5em;
}
.address-compare {
  display: flex;
  flex-direction: column; /* 👈 this makes it stack */
  gap: 12px;
  white-space: pre-line;
}


.address-compare > div {
  flex: 1;
  background: #f9f9f9;
  padding: 10px;
  border: 1px solid #ddd;
}

</style>
